<div class="offers-page">
    <section class="offers-shell">
        <div class="offers-intro">
            <div>
                <p class="eyebrow">Offres entreprise</p>
                <h1>Choisissez l'offre qui active vraiment l'usage</h1>
            </div>
            <div class="intro-side">
                <p class="current-plan" *ngIf="currentPlanLabel">Offre actuelle : {{ currentPlanLabel }}</p>
                <div class="orientation-highlight">
                    <span class="orientation-highlight-label">Appels d'orientation offerts et inclus sur toutes les offres</span>
                </div>
                <p>
                    Côté pilote, suivez l'usage, l'impact et les besoins de vos collaborateurs sans
                    complexifier la gestion.
                </p>
            </div>
        </div>

        <section class="pricing-grid">
            <article
                class="pricing-card"
                *ngFor="let card of cards"
                [class.featured]="card.featured"
                [class.current-plan-card]="card.planCode === currentPlanCode">
                <div class="card-header">
                    <div class="brand-row">
                        <img class="brand-image" [src]="logoSrc" alt="Logo We talk">
                        <h2>
                            <span class="plan-tier">{{ card.tierLabel }}</span>
                        </h2>
                    </div>
                </div>

                <div class="divider"></div>

                <div class="metric-block">
                    <p class="price-label" *ngIf="card.priceLabel">{{ card.priceLabel }}</p>
                    <div class="metric-line">
                        <span class="metric-value">{{ card.metricValue }}</span>
                        <span class="metric-suffix" *ngIf="card.metricSuffix">{{ card.metricSuffix }}</span>
                    </div>
                    <p class="metric-note" *ngIf="card.metricNote">{{ card.metricNote }}</p>
                </div>

                <ul class="benefits-list">
                    <li *ngFor="let bullet of card.bullets; let index = index" [class.is-bold]="index < (card.boldBulletCount ?? 0)">{{ bullet }}</li>
                </ul>

                <div class="secondary-block" *ngIf="card.includedLabel && card.includedValue">
                    <div class="secondary-header">
                        <p>{{ card.includedLabel }}</p>
                    </div>
                    <p class="secondary-value">{{ card.includedValue }}</p>
                </div>

                <div class="discount-block" *ngIf="card.promoPrice">
                    <p class="discount-label">{{ card.promoLabel }}</p>
                    <div class="discount-card">
                        <div class="discount-copy">
                            <p class="discount-original" *ngIf="card.promoOriginalPrice">{{ card.promoOriginalPrice }}</p>
                            <p class="discount-price">{{ card.promoPrice }}</p>
                        </div>
                        <span class="discount-badge" *ngIf="card.promoBadge">{{ card.promoBadge }}</span>
                    </div>
                </div>

                <div class="card-footer">
                    <p class="current-badge current-badge--footer" *ngIf="isCurrentPlan(card.planCode)">
                        <span class="current-badge-dot" aria-hidden="true"></span>
                        Offre actuelle
                    </p>

                    <ng-container *ngIf="!isCurrentPlan(card.planCode)">
                        <app-button
                            [primary]="!card.featured"
                            [warning]="!!card.featured"
                            type="button"
                            (onClick)="handleCardAction(card.planCode)">
                            {{ getCardCtaLabel(card.planCode) }}
                        </app-button>
                    </ng-container>
                </div>
            </article>
        </section>

        <section class="contact-panel">
            <div>
                <p class="contact-kicker">Demande de proposition</p>
                <h2>Recevez la grille complète adaptée à votre entreprise</h2>
                <p>
                    Pour vous envoyer la bonne proposition, nous avons besoin du nom de l'entreprise,
                    d'un contact, d'un email professionnel et d'un numéro de téléphone.
                </p>
            </div>
            <app-button [primary]="true" type="button" (onClick)="requestProposal()">
                Demander la proposition
            </app-button>
        </section>
    </section>
</div>
